import React, { Component } from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';

import GhaRoute from '../privateRoute/GhaRoute';
import ForwarderRoute from '../privateRoute/ForwarderRoute';

import HeaderTitle from './HeaderTitle';
import CartContainer from '../cart/CartContainer';
import ContentWrapper from '../content/ContentWrapper';
import TruckCartContainer from '../truckCart/TruckCartContainer';
import WhsOrderNoteContainer from '../whs/whsOrderNote/WhsOrderNoteContainer';
import CartHeaderContainer from '../cart/cartHeader/CartHeaderContainer';
import PaymentPageContainer from '../paymentPage/PaymentPageContainer';
import WhsOrderDetailsContainer from '../whs/whsOrderDetails/WhsOrderDetailsContainer';
import WhsOrderAwbReportContainer from '../whs/whsOrderAwbReport/WhsOrderAwbReportContainer';
import GhaManageOrdersWrapperContainer from '../gha/manageOrders/GhaManageOrdersWrapperContainer';
import PaymentReportWrapper from '../paymentReport/PaymentReportWrapper';
import FwdOrdersListContainer from '../forwarderPickupOrder/fwdOrders/FwdOrdersListContainer';
import TruckCartHeaderContainer from '../truckCart/truckCartHeader/TruckCartHeaderContainer';
import HeaderContainer from '../forwarderHeader/HeaderContainer';
import DriverSignatureContainer from '../whs/driverSignature/DriverSignatureContainer';
import ForwarderExportContainer from '../forwarderExport/ForwarderExportContainer';
import PickupOrderWrapperContainer from '../pickupOrder/PickupOrderWrapperContainer';
import MyOrderDetailsContainer from '../forwarderPickupOrder/MyOrderDetailsContainer';
import DropOffOrderWrapperContainer from '../dropOffOrder/DropOffOrderWrapperContainer';
import WhsOrderAwbWeightContainer from '../whs/whsOrderAwbWeight/WhsOrderAwbWeightContainer';
import OrdersHeaderContainer from '../common/ordersHeader/OrdersHeaderContainer';
import CreateOrderHeaderContainer from '../common/ordersHeader/CreateOrderHeaderContainer';
import AwbsContainer from '../forwarderImport/awbs/ AwbsContainer';
import CreateGoOrderContainer from '../gha/manageOrders/goOrderAwbs/CreateGoOrderContainer';
import GoCartContainer from '../gha/manageOrders/goOrderAwbs/GoCartContainer';
import GoPaymentPageContainer from '../gha/manageOrders/goOrderAwbs/GoPaymentPageContainer';
import AwbInfoContainer from '../awbInfo/AwbInfoContainer';
import WhsOrderAwbSearchContainer from '../whs/whsOrderAwbSearch/whsOrderAwbSearchContainer';
import WhsMainContainer from '../whs/WhsMainContainer';
import GhaDashboard from '../gha/dashboard/GhaDashboard';
import AnalyticsContainer from '../analytics/AnalyticsContainer';

import User, { UserRoleType } from '../../models/User';

import roleConfig from '../../configs/roles'; 
import styles from '../../App/app.module.css';
import PaymentHeaderContainer from '../paymentPage/paymentHeader/PaymentHeaderContainer';
import PrintUserDetailsContainer from '../administration/UserManagement/UpdateUserPasswordModal/PrintUserDetails/PrintUserDetailsContainer';
import FwdAccountsContainer from '../administration/FwdAccounts/FwdAccountsContainer';
import PaymentOptionsContainer from '../paymentOptions/PaymentOptionsContainer';
import DriveQueueListContainer from '../driverQueue/ghaPage/DriverQueueListContainer';
import UserManagementContainer from '../administration/UserManagement/UserManagementContainer';
import ScreeningDetailsContainer from '../screeningDetails/ScreeningDetailsContainer';
import ScreeningReportContainer from '../screeningReport/ScreeningReportContainer';
import ShipmentInventoryContainer from '../shipmentInventory/ShipmentInventoryContainer';
import RfsContainer from '../rfs/RfsContainer';
import ManifestContainer from '../rfs/manifest/ManifestContainer';
import ManageRfsContainer from '../rfs/manageRfs/ManageRfsContainer';
import TapaContainer from '../tapa/TapaContainer';
import GhaDashboardContainer from '../gha/dashboard/GhaDashboardContainer';
import { receiveDriverQueue } from '../../store/actions/driverQueueAction';
import { receiveCounters } from '../../store/actions/countersAction';
import queueRemote from '../../api/queueRemote';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { receiveError } from '../../store/actions/notificationAction';
import WhsDashboardContainer from '../whs/whsDashboard/WhsDashboardContainer';
import { removeWaitList } from '../../store/actions/waitListAction';

const urls: Array<string> = ['manual-entry-import', 'manual-entry-cart', 'manual-entry-pay', 'manual-entry-issue-po', 'manual-entry-export', 'manual-entry-truck'];

interface HeaderWrapperState { };

interface HeaderWrapperProps extends RouteComponentProps {
  user: User;
  getDriverQueue: () => void;
  getCounters: () => void;
  receiveError: (error: ResponseError) => void;
  waitListId: number;
  removeFromCounter: (driverId: number) => void;
};

class HeaderWrapperContainer extends Component<HeaderWrapperProps, HeaderWrapperState> {

  rerouteToWelcomePage = () => {
    // TODO: FE developer to verify this
    // If we are not on the welcome page and the user haven't been there we need to go there. 
    // Couldn't find a better place for this - Georgi Yovchev
    let changePasswordRoute: any = "/change_first_time_password";
    if (this.props.user &&
      this.props.user.custom_password === false &&
      this.props.location.pathname !== changePasswordRoute) {
      window.location = changePasswordRoute;
    }
  }

  componentDidMount() {
    if (this.props.user.role && this.props.user.role !== 'forwarder') {
      this.props.getDriverQueue();
      this.props.getCounters();
    }
  }

  componentDidUpdate(prevProps: HeaderWrapperProps) {
    if (this.props.waitListId && !urls.includes(this.props.location.pathname.split('/')[1]) && (prevProps.location.pathname.split('/')[1] !== 'manage-imports' && prevProps.location.pathname.split('/')[1] !== 'manage-exports')) {

      this.props.removeFromCounter(this.props.waitListId);
    }
  }

  getRoleTitle = (): string => {
    switch (this.props.user.roleId) {

      case roleConfig.roleId.forwarderUser: return roleConfig.titles.forwarder;
      case roleConfig.roleId.ghaOffice: return roleConfig.titles.ghaOffice;
      case roleConfig.roleId.ghaWarehouse: return roleConfig.titles.ghaWarehouse;
      case roleConfig.roleId.ghaAdmin: return roleConfig.titles.ghaAdmin;
      case roleConfig.roleId.forwarderAdmin: return roleConfig.titles.fwdAdmin;
      case roleConfig.roleId.ghaSupervisor: return roleConfig.titles.ghaSupervisor;
      case roleConfig.roleId.ghaManager: return roleConfig.titles.ghaManager;
      case roleConfig.roleId.ghaAccounting: return roleConfig.titles.ghaAccounting;
      case roleConfig.roleId.ghaScreener: return roleConfig.titles.ghaScreener;
      case roleConfig.roleId.ghaWarehouseScreener: return roleConfig.titles.ghaWarehouseScreener;
      case roleConfig.roleId.ghaDashboard: return roleConfig.titles.ghaDashboard;
      case roleConfig.roleId.ghaAirlineRepresentative: return roleConfig.titles.ghaAirlineRepresentative;
      case roleConfig.roleId.ghaOfflineRFSRep: return roleConfig.titles.ghaOfflineRFSRep;
      case roleConfig.roleId.ghaManagerWh: return roleConfig.titles.ghaManagerWh;
      case roleConfig.roleId.ghaSupervisorWh: return roleConfig.titles.ghaSupervisorWh;
      case roleConfig.roleId.superUser: return roleConfig.titles.superUser;
      case roleConfig.roleId.laxOfficeAgent: return roleConfig.titles.laxOfficeAgent;
      default: return '';
    }
  }

  leaveCounter = (): void => {
    queueRemote.leaveCounter().then((res: ApiResponse<any>) => {
      const result: any | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (result) {
        
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  forwarderPageTitle = (): string => {

    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Manage Pick Ups';
      case 'cart': 
      case 'cart-go': 
      case 'pay': 
      case 'pay-go': 
      case 'issue-po': return 'Manage Pick Ups';
      case 'create-go-order': return sessionStorage.getItem('editGoOrderNumber') ? 'Edit GO Order' : 'Create GO Order';
      case 'my-pick-up-orders': return 'My Pick Up Orders';
      case 'my-drop-off-orders': return 'My Drop Off Orders';
      case 'my-go-orders': return 'GO Orders';
      case 'po': return 'Pick Up Order Details';
      case 'do': return 'Drop Off Order Details'
      case 'drop-off-order':
      case 'my-exports':
      case 'truck': return 'Manage Drop Offs';
      case 'change_first_time_password': return 'Welcome to Trypod';
      case 'payment-options': return 'Payment Options';
      case 'report-payment': return 'Shipment payment details';
      default: return '';
    }
  }

  forwarderAdminPageTitle = (): string => {
    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Users list';
      case 'print-user-details': return 'User Details';
      case 'change_first_time_password': return 'Welcome to Trypod';
      default: return '';
    }
  }

  ghaManagerPageTitle = (): string => {

    if(this.props.location.pathname.split('/')[2] === 'order-awb-search') {
      return 'Order AWB Search';
    }
    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Dashboard';
      case 'analytics': return 'Analytics';
      case 'manage-imports': return 'Manage Pick Ups';
      case 'manage-exports': return 'Manage Drop Offs';
      case 'my-go-orders': return 'GO Orders';
      case 'payment-report' : return 'Shipment payment details';
      case 'manual-entry-import' :
      case 'manual-entry-cart':
      case 'manual-entry-pay':
      case 'manual-entry-issue-po':  return 'Manual Entry Pick Ups';
      case 'cart-go':
      case 'pay-go':
      case 'create-go-order': return sessionStorage.getItem('editGoOrderNumber') ? 'Edit GO Order' : 'Create GO Order';
      case 'my-go-orders': return 'GO Orders';
      case 'manual-entry-export' :
      case 'manual-entry-truck':
      case 'manual-entry-drop-off-order': return 'Manual Entry Drop Offs'; 
      case 'awb-info': return 'AWB Info';
      case 'screening': return 'Screening Details';
      case 'screening-report': return 'Screening Report';
      case 'shipment-inventory': return 'Shipment Inventory';
      case 'change_first_time_password': return 'Welcome to Trypod';
      case 'driver-queue-list': return 'Driver Waiting List';
      case 'dashboard-waiting-list': return 'Dashboard / Waiting List';
      case 'user-management': return 'Users list';
      case 'manage-rfs': return 'Manage RFS';
      case 'create-manifest': return 'Manage RFS';
      case 'create-rfs': return 'Create RFS';
      case 'print-user-details': return 'User Details';
      case 'dock-activity': return 'Dock Activity';
      case 'whs': return 'Warehouse Order Details';
      case 'tapa': return 'TAPA Inspection';
      default: return '';
    }
  }

  ghaSuperUserPageTitle = (): string => {

    if(this.props.location.pathname.split('/')[2] === 'order-awb-search') {
      return 'Order AWB Search';
    }
    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Dashboard';
      case 'manage-imports': return 'Manage Imports';
      case 'manage-exports': return 'Manage Exports';
      case 'payment-report' : return 'Shipment payment details';
      case 'manual-entry-import' :
      case 'manual-entry-cart':
      case 'manual-entry-pay':
      case 'manual-entry-issue-po':  return 'Manual Entry Pick Ups';
      case 'cart-go':
      case 'pay-go':
      case 'create-go-order': return sessionStorage.getItem('editGoOrderNumber') ? 'Edit GO Order' : 'Create GO Order';
      case 'my-go-orders': return 'GO Orders';
      case 'manual-entry-export' : return 'Manual Entry Drop Offs';
      case 'manual-entry-truck':
      case 'manual-entry-drop-off-order': return 'Manual Entry Drop Offs'; 
      case 'awb-info': return 'AWB Info';
      case 'screening': return 'Screening Details';
      case 'screening-report': return 'Screening Report';
      case 'shipment-inventory': return 'Shipment Inventory';
      case 'change_first_time_password': return 'Welcome to Trypod';
      case 'driver-queue-list': return 'Driver Waiting List';
      case 'dashboard-waiting-list': return 'Dashboard / Waiting List';
      case 'user-management': return 'Users list';
      case 'manage-rfs': return 'Manage RFS';
      case 'create-manifest': return 'Manage RFS';
      case 'create-rfs': return 'Create RFS';
      case 'print-user-details': return 'User Details';
      case 'dock-activity': return 'Dock Activity';
      case 'whs': return 'Warehouse Order Details';
      default: return '';
    }
  }

  ghaSupervisorPageTitle = (): string => {

    if(this.props.location.pathname.split('/')[2] === 'order-awb-search') {
      return 'Order AWB Search';
    }
    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Dashboard / Waiting List';
      case 'analytics': return 'Analytics';
      case 'manage-imports': return 'Manage Imports';
      case 'manage-exports': return 'Manage Exports';
      case 'payment-report' : return 'Shipment payment details';
      case 'manual-entry-import' :
      case 'manual-entry-cart':
      case 'manual-entry-pay':
      case 'manual-entry-issue-po':  return 'Manual Entry Pick Ups';
      case 'cart-go':
      case 'pay-go':
      case 'create-go-order': return sessionStorage.getItem('editGoOrderNumber') ? 'Edit GO Order' : 'Create GO Order';
      case 'my-go-orders': return 'GO Orders';
      case 'manual-entry-export' : return 'Manual Entry Drop Offs';
      case 'manual-entry-truck':
      case 'manual-entry-drop-off-order': return 'Manual Entry Drop Offs'; 
      case 'awb-info': return 'AWB Info';
      case 'screening': return 'Screening Details';
      case 'screening-report': return 'Screening Report';
      case 'shipment-inventory': return 'Shipment Inventory';
      case 'change_first_time_password': return 'Welcome to Trypod';
      case 'driver-queue-list': return 'Driver Waiting List';
      case 'dashboard-waiting-list': return 'Dashboard / Waiting List';
      case 'user-management': return 'Users list';
      case 'manage-rfs': return 'Manage RFS';
      case 'create-manifest': return 'Manage RFS';
      case 'create-rfs': return 'Create RFS';
      case 'fwd-accounts': return 'Forwarder Accounts';
      case 'print-user-details': return 'User Details';
      case 'dock-activity': return 'Dock Activity';
      case 'whs': return 'Warehouse Order Details';
      case 'tapa': return 'TAPA Inspection';
      default: return '';
    }
  }

  ghaWarehousePageTitle = (): string => {
    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Dock Activity'; 
      case 'whs': return 'Warehouse Order Details';
      case 'tapa': return 'TAPA Inspection';
      default: return '';
    }
}

  ghaAdminPageTitle = (): string => {

    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Shipment payment details'; 
      case 'analytics': return 'Analytics';
      case 'awb-info': return 'AWB Info';
      case 'user-management': return 'Users list';
      case 'screening-report': return 'Screening Report';
      case 'shipment-inventory': return 'Shipment Inventory';
      case 'print-user-details': return 'User Details';
      case 'change_first_time_password': return 'Welcome to Trypod';
      case 'fwd-accounts': return 'Forwarder Accounts';
      default: return '';
    }
  }

  getDashboardPageTitle = (): string => {

    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Dashboard / Waiting List'; 
      case 'driver-queue-list': return 'Driver Waiting List';
      case 'dashboard': return 'Dashboard';
      default: return '';
    }
  }


  ghaScreenerPageTitle = (): string => {
    switch (this.props.location.pathname.split('/')[1]) {
      case '': return 'Screening Details';
      case 'screening-report': return 'Screening Report';
      default: return '';
    }
  }

  ghaAirlineRepPageTitle = (): string => {
    switch (this.props.location.pathname.split('/')[1]) {
      case '': return 'Shipment Inventory';
      case 'analytics': return 'Analytics';
      case 'screening-report': return 'Screening Report';
      default: return '';
    }
  }

  ghaOfflinePageTitle = (): string => {
    switch (this.props.location.pathname.split('/')[1]) {
      case '': return 'Dashboard';
      case 'create-rfs' : return 'Create RFS';
      case 'create-manifest' : return 'Create RFS';
      case 'manage-rfs': return 'Manage RFS';
      default: return '';
    }
  }

  laxOfficeAgentPageTitle = (): string => {

    if(this.props.location.pathname.split('/')[2] === 'order-awb-search') {
      return 'Order AWB Search';
    }
    switch (this.props.location.pathname.split('/')[1]) {

      case '': return 'Dashboard';
      case 'manage-imports': return 'Manage Imports';
      case 'manage-exports': return 'Manage Exports';
      case 'manual-entry-import' :
      case 'manual-entry-cart':
      case 'manual-entry-pay':
      case 'manual-entry-issue-po':  return 'Manual Entry Pick Ups';
      case 'cart-go':
      case 'pay-go':
      case 'create-go-order': return sessionStorage.getItem('editGoOrderNumber') ? 'Edit GO Order' : 'Create GO Order';
      case 'my-go-orders': return 'GO Orders';
      case 'manual-entry-export' : return 'Manual Entry Drop Offs';
      case 'manual-entry-truck':
      case 'manual-entry-drop-off-order': return 'Manual Entry Drop Offs'; 
      case 'awb-info': return 'AWB Info';
      case 'screening': return 'Screening Details';
      case 'screening-report': return 'Screening Report';
      case 'shipment-inventory': return 'Shipment Inventory';
      case 'change_first_time_password': return 'Welcome to Trypod';
      case 'manage-rfs': return 'Manage RFS';
      case 'create-manifest': return 'Manage RFS';
      case 'create-rfs': return 'Create RFS';
      case 'whs': return 'Warehouse Order Details';
      case 'tapa': return 'TAPA Inspection';
      default: return '';
    }
  }

  forwarderHeaderChildren = (): JSX.Element | null => {

    switch (this.props.location.pathname.split('/')[1]) {

      case '': return this.props.user.role === roleConfig.roles.forwarder ? <HeaderContainer type='import' userRole={ UserRoleType.FORWARDER } /> : null; 
      case 'cart': return <CartHeaderContainer />;
        case 'pay': return <PaymentHeaderContainer userRole={ UserRoleType.FORWARDER }/>;
      case 'my-pick-up-orders':
      case 'issue-po': return <CreateOrderHeaderContainer />;
      case 'drop-off-order': return <CreateOrderHeaderContainer/>;
      case 'my-exports': return <HeaderContainer type='export' userRole={ UserRoleType.FORWARDER } />;
      case 'report-payment': return <TruckCartHeaderContainer />;
      case 'truck': return <TruckCartHeaderContainer />;
      case 'po': 
        const poNumber : string = this.props.location.pathname.split('/')[2];
        return <OrdersHeaderContainer type='po' orderNumber={ poNumber } />;
      case 'do': 
        const doNumber : string = this.props.location.pathname.split('/')[2];
        return <OrdersHeaderContainer type='do' orderNumber={ doNumber } />;
      default: return null;
    }
  }

  ghaHeaderChildren = (): JSX.Element | null => {

    const userRole: number = this.props.user.roleId;
    const configRole: {[key: string]: number } = roleConfig.roleId;
    const isOpenManageAndManualHeaders: boolean = !!(userRole === configRole.ghaOffice || userRole === configRole.ghaSupervisor || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaManager);
    
    if (isOpenManageAndManualHeaders) {
      switch (this.props.location.pathname.split('/')[1]) {
        case '': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'manage-imports': return <HeaderContainer type='import' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'manage-exports': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'awb-info': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'manage-rfs': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'create-rfs': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'create-manifest': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'screening-report': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'driver-queue-list': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'payment-report': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'user-management': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'dashboard-waiting-list': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'shipment-inventory': return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'not-manual' } />;
        case 'manual-entry-import' : return <HeaderContainer type='import' userRole={ UserRoleType.GHA } operation={ 'manual' } />;
        case 'manual-entry-export' : return <HeaderContainer type='export' userRole={ UserRoleType.GHA } operation={ 'manual' } />;
        case 'manual-entry-issue-po': return <CreateOrderHeaderContainer />;
        case 'manual-entry-pay': return <PaymentHeaderContainer userRole={ UserRoleType.GHA } />;
        case 'manual-entry-drop-off-order': return <CreateOrderHeaderContainer />;
          case 'my-go-orders': return <HeaderContainer type='import' userRole={ UserRoleType.GHA } operation={'not-manual'}/>;
          case 'create-go-order': return (
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', alignItems: 'center' }}>
              <HeaderContainer type='import' userRole={ UserRoleType.GHA } operation={ 'manual' } isGoOrder={ true } />
            </div>
          );
          case 'cart-go': return <CartHeaderContainer />;
          case 'pay-go': return <PaymentHeaderContainer userRole={ UserRoleType.GHA } />;
          default: return null;
        }
      }

      return null;
    }

  render() {
    this.rerouteToWelcomePage();

    const userRoleTitle: string = this.getRoleTitle();
    let pageTitle: string = this.forwarderPageTitle();
    let headerChildren: JSX.Element | null = this.forwarderHeaderChildren();
    const userRole: number = this.props.user.roleId;
    const configRole: {[key: string]: number } = roleConfig.roleId;

    if (userRole === configRole.forwarderAdmin) {
      pageTitle = this.forwarderAdminPageTitle();
    }

    if (userRole === configRole.ghaOffice ||
      userRole === configRole.ghaManager) {
      pageTitle = this.ghaManagerPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if (userRole === configRole.laxOfficeAgent) {
      pageTitle = this.laxOfficeAgentPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if (userRole === configRole.ghaSupervisor || userRole === configRole.ghaManagerWh
      || userRole === configRole.ghaSupervisorWh) {
      pageTitle = this.ghaSupervisorPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if (userRole === configRole.ghaWarehouse || userRole === configRole.ghaWarehouseScreener) {
      pageTitle = this.ghaWarehousePageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if (userRole === configRole.superUser) {
      pageTitle = this.ghaSuperUserPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if (userRole === configRole.ghaDashboard) {
      pageTitle = this.getDashboardPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }


    if (userRole === configRole.ghaAdmin || userRole === configRole.ghaAccounting) {
      pageTitle = this.ghaAdminPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if (userRole === configRole.ghaScreener) {
      pageTitle = this.ghaScreenerPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if(userRole === configRole.ghaAirlineRepresentative) {
      pageTitle = this.ghaAirlineRepPageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    if (userRole === configRole.ghaOfflineRFSRep) {
      pageTitle = this.ghaOfflinePageTitle();
      headerChildren = this.ghaHeaderChildren();
    }

    const showHeader = this.props.location.pathname.split('/')[1] === 'dashboard' || this.props.location.pathname.split('/')[1] === 'whs-dashboard';

    return (
      <div className={ styles.container }>
        
       { !showHeader &&
        <HeaderTitle titlePage={ pageTitle } titleRole={ userRoleTitle }>{ headerChildren }</HeaderTitle>}

        <div className={ `${styles.flexGrow1} ${styles.mainContent}` }>
          <Switch>
            <ForwarderRoute exact path='/truck' component={ TruckCartContainer } componentProps={{ userRole: UserRoleType.FORWARDER }} />
            <ForwarderRoute exact path='/drop-off-order' component={ DropOffOrderWrapperContainer } componentProps={{ userRole: UserRoleType.FORWARDER }} />
            <GhaRoute exact path='/manage-imports' component={ GhaManageOrdersWrapperContainer } componentProps={{ type: 'po' }}/> 
            <GhaRoute exact path='/manage-exports' component={ GhaManageOrdersWrapperContainer } componentProps={{ type: 'do' }} />
            <GhaRoute exact path='/awb-info' component={ AwbInfoContainer} />

            <GhaRoute exact path='/manual-entry-import' component={ AwbsContainer } componentProps={{ userRole: UserRoleType.GHA }}/> 
            <GhaRoute exact path='/manual-entry-export' component={ ForwarderExportContainer } componentProps={{ userRole: UserRoleType.GHA }}/> 
            <GhaRoute exact path='/manual-entry-cart' component={ CartContainer } componentProps={{ userRole: UserRoleType.GHA }}/> 
            <GhaRoute exact path='/manual-entry-pay' component={ PaymentPageContainer } componentProps={{ userRole: UserRoleType.GHA }}/> 
            <GhaRoute exact path='/manual-entry-issue-po' component={ PickupOrderWrapperContainer } componentProps={{ userRole: UserRoleType.GHA }}/> 
            <GhaRoute exact path='/manual-entry-truck' component={ TruckCartContainer } componentProps={{ userRole: UserRoleType.GHA }}/> 
            <GhaRoute exact path='/manual-entry-drop-off-order' component={ DropOffOrderWrapperContainer } componentProps={{ userRole: UserRoleType.GHA }}/> 
            <GhaRoute exact path='/driver-queue-list' component={ DriveQueueListContainer } />
            <GhaRoute exact path='/dock-activity' component={ WhsMainContainer } />
            <GhaRoute exact path='/user-management' component={ UserManagementContainer } />
            <GhaRoute exact path='/screening/:code?/:number?/:version?/:orderNumber?' component={ ScreeningDetailsContainer } />
            <GhaRoute exact path='/screening-report' component={ ScreeningReportContainer } />
            <GhaRoute exact path='/shipment-inventory' component={ ShipmentInventoryContainer } />
            <GhaRoute exact path='/payment-report' component={ PaymentReportWrapper } />
            <GhaRoute exact path='/tapa' component={ TapaContainer } />


            <ForwarderRoute exact path='/my-pick-up-orders' component={ FwdOrdersListContainer } componentProps={{ type: 'po' }} />
            <ForwarderRoute exact path='/my-drop-off-orders' component={ FwdOrdersListContainer } componentProps={{ type: 'do' }} />
            <GhaRoute exact path='/my-go-orders' component={ FwdOrdersListContainer } componentProps={{ type: 'go' }} />
            <GhaRoute exact path='/create-go-order' component={ CreateGoOrderContainer } componentProps={{ userRole: UserRoleType.GHA, type: 'go' }} />
            <GhaRoute exact path='/cart-go' component={ GoCartContainer } componentProps={{ userRole: UserRoleType.GHA, type: 'go' }} />
            <GhaRoute exact path='/pay-go' component={ GoPaymentPageContainer } componentProps={{ userRole: UserRoleType.GHA, type: 'go' }}/>
            <ForwarderRoute exact path='/po/:orderNumber' component={ MyOrderDetailsContainer } componentProps={{ type: 'po' }} />
            <ForwarderRoute exact path='/do/:orderNumber' component={ MyOrderDetailsContainer } componentProps={{ type: 'do' }} />
            <GhaRoute exact path='/go/:orderNumber' component={ MyOrderDetailsContainer } componentProps={{ type: 'go' }} />
            <ForwarderRoute exact path='/cart' component={ CartContainer } componentProps={{ userRole: UserRoleType.FORWARDER }} />
            <ForwarderRoute exact path='/pay' component={ PaymentPageContainer } componentProps={{ userRole: UserRoleType.FORWARDER }}/>
            <ForwarderRoute exact path='/issue-po' component={ PickupOrderWrapperContainer } componentProps={{ userRole: UserRoleType.FORWARDER }}/>
            <ForwarderRoute exact path='/my-exports' component={ ForwarderExportContainer } componentProps={{ userRole: UserRoleType.FORWARDER }} />
            <ForwarderRoute exact path='/payment-options' component={ PaymentOptionsContainer } componentProps={{ userRole: UserRoleType.FORWARDER }} />
            <ForwarderRoute exact path="/report-payment" component={ PaymentReportWrapper } />
            
            <GhaRoute exact path='/whs/po/note/:number' component={ WhsOrderNoteContainer } componentProps={{ type: 'po' }} />
            <GhaRoute exact path='/whs/go/note/:number' component={ WhsOrderNoteContainer } componentProps={{ type: 'go' }} />
            <GhaRoute exact path='/whs/do/note/:number' component={ WhsOrderNoteContainer } componentProps={{ type: 'do' }} />
            <GhaRoute exact path='/whs/rfs/note/:number' component={ WhsOrderNoteContainer } componentProps={{ type: 'rfs' }} />
            <GhaRoute exact path='/whs/po/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion' component={ WhsOrderAwbReportContainer } componentProps={{ type: 'po' }} />
            <GhaRoute exact path='/whs/go/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion' component={ WhsOrderAwbReportContainer } componentProps={{ type: 'go' }} />
            <GhaRoute exact path='/whs/do/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion' component={ WhsOrderAwbReportContainer } componentProps={{ type: 'do' }} />
            <GhaRoute exact path='/whs/do/awb/weight/:orderNumber/:awbCode/:awbNumber/:awbVersion' component={ WhsOrderAwbWeightContainer } />
            <GhaRoute exact path='/whs/rfs/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion' component={ WhsOrderAwbReportContainer } componentProps={{ type: 'rfs' }} />
            <GhaRoute exact path='/whs/rfs/awb/weight/:orderNumber/:awbCode/:awbNumber/:awbVersion' component={ WhsOrderAwbWeightContainer } />
            <GhaRoute exact path='/whs/order-awb-search' component={ WhsOrderAwbSearchContainer } />
            <GhaRoute exact path='/whs/po/:number' component={ WhsOrderDetailsContainer } componentProps={{ type: 'po' }} />
            <GhaRoute exact path='/whs/go/:number' component={ WhsOrderDetailsContainer } componentProps={{ type: 'go' }} />
            <GhaRoute exact path='/whs/do/:number' component={ WhsOrderDetailsContainer } componentProps={{ type: 'do' }} />
            <GhaRoute exact path='/whs/rfs/:number' component={ WhsOrderDetailsContainer } componentProps={{ type: 'rfs' }} />
            <GhaRoute exact path='/whs/po/drv-signature/:number' component={ DriverSignatureContainer } componentProps={{ type: 'po', return: false }} />
            <GhaRoute exact path='/whs/go/drv-signature/:number' component={ DriverSignatureContainer } componentProps={{ type: 'go', return: false }} />
            <GhaRoute exact path='/whs/do/drv-signature/:number' component={ DriverSignatureContainer } componentProps={{ type: 'do', return: false }} />
            <GhaRoute exact path='/whs/rfs/drv-signature/:number' component={ DriverSignatureContainer } componentProps={{ type: 'rfs', return: false }} />
            <GhaRoute exact path='/whs/do/return-drv-signature/:number' component={ DriverSignatureContainer } componentProps={{ type: 'do', return: true }} />
            <GhaRoute exact path='/whs/do/return-drv-signature/:number/:awbCode/:awbNumber/:awbVersion' component={ DriverSignatureContainer } componentProps={{ type: 'do', return: true }} />
            
            <GhaRoute exact path='/whs-dashboard' component={ WhsDashboardContainer } />
            <GhaRoute exact path='/print-user-details' component={ PrintUserDetailsContainer } />
            <GhaRoute exact path='/fwd-accounts' component={ FwdAccountsContainer } />
            <GhaRoute path='/create-rfs/:id?' component={ RfsContainer } componentProps={{ userRole: UserRoleType.GHA }} />
            <GhaRoute exact path='/create-manifest/:id?' component={ManifestContainer} componentProps={{ userRole: UserRoleType.GHA }} />
            <GhaRoute exact path='/manage-rfs' component={ManageRfsContainer} componentProps={{ userRole: UserRoleType.GHA }} />
            <GhaRoute exact path='/analytics/:tab?' component={ AnalyticsContainer } componentProps={{ userRole: UserRoleType.GHA }}/>
            <GhaRoute exact path='/dashboard' component={GhaDashboardContainer} componentProps={{ userRole: UserRoleType.GHA }} />
            
            <Route exact path='/' component={ ContentWrapper } />
          </Switch>
        </div>
          
      </div>
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    waitListId: state.driverReducer 
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getDriverQueue: () => dispatch(receiveDriverQueue()),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    getCounters: () => dispatch(receiveCounters()),
    removeFromCounter: (id: number) => dispatch(removeWaitList(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrapperContainer);
